module.exports = __webpack_public_path__ + "media/images/avatar/26-9f0509beec8ca38c298ddc502632028f.svg";